"use strict";
/**
 * EN16931-aligned South African e-invoice data model.
 *
 * Shaped for SARS VAT Modernisation (Consultation Paper, Aug 2026): the
 * Decentralised Continuous Transaction Control & Exchange (DCTCE) 5-corner
 * model built on e-Invoicing, an Interoperability Framework and e-Reporting.
 *
 * Field names track EN16931 Business Terms (BT-*) so that mapping to the final
 * SARS CIUS / Peppol PINT BIS syntax (to be published in Phase 2, 2027/28) is
 * a serialisation concern only, not a re-modelling exercise.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPE_CODE = void 0;
/** UNTDID 1001 document type codes used by EN16931 (BT-3). */
exports.TYPE_CODE = {
    invoice: 380,
    'credit-note': 381,
    'debit-note': 383,
};
